/**
 * Ir_side_nav
 * @constructor
 */
class Ir_side_nav {
  constructor() {}
  /**
   * コモン
   */
  init() {

    if(document.URL.match('/corporate/')) {
      var path = location.pathname
      var pc = window.matchMedia("(min-width: 768px)").matches;
      var sp = window.matchMedia("(max-width: 767px)").matches;
    
      if(sp) {
        $('.js-managementpolicy-ttl').attr('href','javascript:void(0)');
        $('.js-library-ttl').attr('href','javascript:void(0)');
        $('.js-stockinformation-ttl').attr('href','javascript:void(0)');
        $('.js-highlight-ttl').attr('href','javascript:void(0)');
      }
      
      //経営方針共通
      if(document.URL.match('/corporate/ir/managementpolicy/')) {
        $('.js-managementpolicy-child').show();
        $('.js-managementpolicy-ttl').next().addClass('is-active');
      }
      //経営方針TOP
      if (path == "/corporate/ir/managementpolicy/") {
        $('.js-managementpolicy-ttl').addClass('color-orange');
      }
      //経営方針TOP > 中期経営計画
      if (path == "/corporate/ir/managementpolicy/management-plan/"){
        $('.managementpolicy-child--01 a').addClass('color-orange');
      }
      //経営方針TOP > コーポレートガバナンス
      if (path == "/corporate/ir/managementpolicy/governance/"){
        $('.managementpolicy-child--02 a').addClass('color-orange');
      }
      //経営方針TOP > ライブラリ > ディスクロージャーポリシー
      if (path == "/corporate/ir/managementpolicy/policy/"){
        $('.managementpolicy-child--03 a').addClass('color-orange');
      }
      
      //IRライブラリ共通
      if(document.URL.match('/corporate/ir/library/')) {
        $('.js-library-child').show();
        $('.js-library-ttl').next().addClass('is-active');
      }
      //IRライブラリTOP
      if (path == "/corporate/ir/library/") {
        $('.js-library-ttl').addClass('color-orange');
      }
      //IRライブラリTOP > 決算短信
      if (path == "") {
        $('.library-child--01 a').addClass('color-orange');
      }
      //IRライブラリTOP > 有価証券報告書
      if (path == "") {
        $('.library-child--02 a').addClass('color-orange');
      }
      //IRライブラリTOP > 業績説明資料
      if (path == "") {
        $('.library-child--03 a').addClass('color-orange');
      }
      //IRライブラリTOP > 統合報告書
      if (path == "") {
        $('.library-child--04 a').addClass('color-orange');
      }
      //IRライブラリTOP > IRカレンダー
      if (path == "") {
        $('.library-child--05 a').addClass('color-orange');
      }
      
      //株式情報共通
      if(document.URL.match('/corporate/ir/stockinformation/')) {
        $('.js-stockinformation-child').show();
        $('.js-stockinformation-ttl').next().addClass('is-active');
      }
      //株式情報TOP
      if (path == "/corporate/ir/stockinformation/") {
        $('.js-stockinformation-ttl').addClass('color-orange');
      }
      //株式情報TOP > 株式メモ
      if (path == "/corporate/ir/stockinformation/shareholder/") {
        $('.stockinformation-child--01 a').addClass('color-orange');
      }
      //株式情報TOP > 株主総会
      if (path == "/corporate/ir/stockinformation/generalmeeting/") {
        $('.stockinformation-child--05 a').addClass('color-orange');
      }
      //株式情報TOP > 電子公告
      if (path == "/corporate/ir/stockinformation/publication/") {
        $('.stockinformation-child--06 a').addClass('color-orange');
      }
      //株式情報TOP > ストックオプション情報
      if (path == "/corporate/ir/stockinformation/stockoption/") {
        $('.stockinformation-child--03 a').addClass('color-orange');
      }
      //株式情報TOP > 株式分割情報
      if (path == "/corporate/ir/stockinformation/stocksplit/") {
        $('.stockinformation-child--04 a').addClass('color-orange');
      }
      //株式情報TOP > 自己株式情報
      if (path == "/corporate/ir/stockinformation/treasurystock/") {
        $('.stockinformation-child--02 a').addClass('color-orange');
      }
      
      //財務ハイライト共通
      if(document.URL.match('/corporate/ir/highlight/')) {
        $('.js-highlight-child').show();
        $('.js-highlight-ttl').next().addClass('is-active');
      }
      //財務ハイライトTOP
      if (path == "/corporate/ir/highlight/") {
        $('.js-highlight-ttl').addClass('color-orange');
      }
      //財務ハイライトTOP > 財務指標
      if (path == "/corporate/ir/highlight/indicator/") {
        $('.highlight-child--01 a').addClass('color-orange');
      }
      //財務ハイライトTOP > 連結貸借対照表
      if (path == "/corporate/ir/highlight/bs/") {
        $('.highlight-child--02 a').addClass('color-orange');
      }
      //財務ハイライトTOP > 連結損益計算書
      if (path == "/corporate/ir/highlight/pl/") {
        $('.highlight-child--03 a').addClass('color-orange');
      }
      //財務ハイライトTOP > 連結キャッシュフロー計算書
      if (path == "/corporate/ir/highlight/cf/") {
        $('.highlight-child--04 a').addClass('color-orange');
      }
      
      //IRニュース共通
      if(document.URL.match('/corporate/ir/news/')) {
        $('.js-news-child').show();
      }
      //IRニュースTOP
      if (path == "/corporate/ir/news/") {
        $('.js-news-ttl').addClass('color-orange');
      }
      
      //免責事項共通
      if(document.URL.match('/corporate/ir/responsibility/')) {
        $('.js-news-child').show();
      }
      //免責事項TOP
      if (path == "/corporate/ir/responsibility/") {
        $('.js-responsibility-ttl').addClass('color-orange');
      }
      
      //よくあるご質問共通
      if(document.URL.match('/corporate/ir/faq/')) {
        $('.js-news-child').show();
      }
      //よくあるご質問TOP
      if (path == "/corporate/ir/faq/") {
        $('.js-faq-ttl').addClass('color-orange');
      }

      if(sp) {
        $('.js-ir-side-toggle').on('click', function () {
          $(this).toggleClass('is-active');
          $(this).next().stop().slideToggle();
        })
      }
    }
  }
}

export default Ir_side_nav;